import { useEffect, useState } from "react";

const useSearchList = (skip, setSkip, take, dataLength, total) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(false);
  }, [dataLength, total]);

  const loadMoreItems = () => {
    setIsLoading(true);
    setSkip((currentSkip) => currentSkip + take);
  };

  const montaEndereco = (endereco) => {
    return `${endereco.rua ? endereco.rua + " " : ""}${endereco.numero ? endereco.numero + " " : ""}${
      endereco.complemento ? endereco.complemento + " " : ""
    }${endereco.bairro ? "- " + endereco.bairro + " " : ""}${
      endereco.cidade?.nome ? "- " + endereco.cidade?.nome : ""
    }${endereco.cidade?.estado?.sigla ? "/" + endereco.cidade?.estado?.sigla + " " : ""}${
      endereco.cep ? "- " + endereco.cep : ""
    }`;
  };

  const renderTagContent = (item) => {
    if (!item?.codigo && item?.codigoProspect) return "Prospect";
    if ([1, 2].includes(item?.tipo)) return "Emissor/Recebedor";
    else if ([3, 4].includes(item?.tipo)) return "Recebedor";
    return "";
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return {
    isLoading,
    setIsLoading,
    loadMoreItems,
    montaEndereco,
    renderTagContent,
    scrollToTop
  };
};

export default useSearchList;